<template>
    <v-container fluid>
        <v-row>
            <v-container fluid>
                <v-card>
                    <v-card-text>
                        <v-row align="center" justify="center">
                            <v-col cols="12" sm="6"> </v-col>
                            <v-col cols="12" sm="6">
                                <v-row>
                                    <v-col cols="12"> <strong>ACTIONS</strong></v-col>

                                    <v-col cols="12" align="start" justify="center"
                                        ><v-btn class="mx-1" small color="green" dark @click="downloadHandle">
                                            DESCARGAR <v-icon right dark> mdi-arrow-down-box </v-icon>
                                        </v-btn>
                                        <v-btn class="mx-1" small color="primary" dark @click="openForm(1)"> CREAR </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-container>
        </v-row>
        <v-row>
            <v-col cols="12"
                ><v-card>
                    <v-card-title dark>
                        <strong>PERFILES DE ORIGEN</strong>
                        <v-spacer />
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="BUSCAR" single-line hide-details />
                    </v-card-title>
                    <v-card-text
                        ><v-data-table
                            item-key="id"
                            flat
                            :headers="headers"
                            :items="lista"
                            :search="search"
                            :loading="loading"
                            :sort-by="['fechaCreacion']"
                            :sort-desc="[true]"
                            loading-text="...Cargando"
                        >
                            <template v-slot:[`item.fechaCreacion`]="{ item }">
                                {{ item.fechaCreacion | fechaISO }}
                            </template>
                            <template v-slot:[`item.origenes`]="{ item }">
                                {{ item.origenes ? item.origenes.length : 0 }} orígenes
                            </template>
                            <template v-slot:[`item.usuarios`]="{ item }">
                                <v-chip small :color="getUsuariosCount(item.id) > 0 ? 'green' : 'grey'" dark>
                                    {{ getUsuariosCount(item.id) }}
                                </v-chip>
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon color="green" @click="openForm(4, item)"> mdi-eye </v-icon>
                                <v-icon color="blue" @click="openForm(2, item)"> mdi-pencil </v-icon>
                                <v-icon color="purple" @click="openForm(5, item)"> mdi-content-copy </v-icon>
                                <v-icon color="red" @click="openForm(3, item)"> mdi-delete </v-icon>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="openDialog" v-if="openDialog" persistent max-width="720px" scrollable>
            <v-card>
                <v-card-title class="grey lighten-5">
                    <strong>{{ modalText }} PERFIL DE ORIGEN</strong>
                </v-card-title>
                <v-card-text style="max-height: 70vh; overflow-y: auto;">
                    <v-container class="pa-3" align="center">
                        <v-row align="center">
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="datos.nombre"
                                    v-validate="'required'"
                                    dense
                                    hide-details="auto"
                                    outlined
                                    label="Nombre*"
                                    :error-messages="errors.collect('datos.nombre')"
                                    data-vv-name="datos.nombre"
                                    required
                                />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="datos.descripcion"
                                    dense
                                    hide-details="auto"
                                    outlined
                                    label="Descripción"
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-card class="blue lighten-5">
                                    <v-card-title class="subtitle-2">
                                        ORÍGENES DEL PERFIL
                                        <v-spacer />
                                        <v-chip small outlined>{{ selectedOrigenes.length }} seleccionados</v-chip>
                                    </v-card-title>
                                    <v-card-text>
                                        <div v-if="selectedOrigenes.length > 0" class="mb-3">
                                            <v-chip
                                                v-for="sel in selectedOrigenes"
                                                :key="'sel-'+sel.idOrigen"
                                                small
                                                close
                                                class="ma-1"
                                                color="blue"
                                                dark
                                                @click:close="toggleOrigen(sel.idOrigen, false)"
                                            >
                                                {{ getOrigenName(sel.idOrigen) }}
                                            </v-chip>
                                        </div>
                                        <v-text-field
                                            v-model="searchOrigen"
                                            prepend-inner-icon="mdi-magnify"
                                            label="Buscar origen..."
                                            dense
                                            hide-details
                                            outlined
                                            clearable
                                            class="mb-2"
                                        />
                                        <v-list dense>
                                            <template v-for="canal in listaCanales">
                                                <template v-if="getOrigenesByCanal(canal.id).length > 0">
                                                    <v-subheader :key="'h-'+canal.id" class="blue--text font-weight-bold">
                                                        {{ canal.descripcion }}
                                                        <v-spacer />
                                                        <v-btn x-small text color="blue" @click="selectAllCanal(canal.id)">Todos</v-btn>
                                                        <v-btn x-small text color="grey" @click="deselectAllCanal(canal.id)">Ninguno</v-btn>
                                                    </v-subheader>
                                                    <template v-for="ori in getOrigenesByCanal(canal.id)">
                                                        <v-list-item :key="'o-'+ori.id" dense>
                                                            <v-list-item-action>
                                                                <v-checkbox
                                                                    :input-value="isOrigenSelected(ori.id)"
                                                                    @change="toggleOrigen(ori.id, $event)"
                                                                    hide-details
                                                                    dense
                                                                />
                                                            </v-list-item-action>
                                                            <v-list-item-content>
                                                                <v-list-item-title class="caption">{{ ori.descripcion }}</v-list-item-title>
                                                            </v-list-item-content>
                                                            <v-list-item-action v-if="isOrigenSelected(ori.id)">
                                                                <v-switch
                                                                    :input-value="getSameGroup(ori.id)"
                                                                    @change="toggleSameGroup(ori.id, $event)"
                                                                    label="Grupo"
                                                                    hide-details
                                                                    dense
                                                                    class="caption"
                                                                />
                                                            </v-list-item-action>
                                                        </v-list-item>
                                                    </template>
                                                    <v-divider :key="'d-'+canal.id" />
                                                </template>
                                            </template>
                                        </v-list>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12">
                                <small>*Campos Obligatorios</small>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="grey lighten-5">
                    <v-spacer />
                    <v-btn color="darken-1" text @click="EMPTY_FORM"> CERRAR </v-btn>
                    <v-btn v-if="step != 4" :loading="loadingBTN" color="primary" @click="fnHandleCrud"> {{ modalText }} </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <Delete :open="openDelete" :loadingBTN="loadingBTN" @handle-delete="fnHandlePut" @closeModal="closeDocumento" />
    </v-container>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { exportXLSX } from '@/utils'
import { mixins } from '@/mixins/mixin.js'
import Delete from '@/components/modals/Delete'

const defaultText = 'REGISTRAR'

export default {
    components: {
        Delete
    },
    mixins: [mixins],

    data() {
        return {
            selectedOrigenes: [],
            searchOrigen: '',
            menu: false,
            fechaFiltro: new Date().toISOString().substr(0, 7),
            openDialog: false,
            openDelete: false,
            openDocumento: false,
            search: '',
            singleSelect: true,
            loadingBTN: false,
            selected: null,
            modalText: defaultText,
            step: 1,
            loading: false,
            headers: [
                { text: 'Actions', value: 'actions', sortable: false },
                { text: 'ID', value: 'id' },
                { text: 'Nombre', value: 'nombre' },
                { text: 'Descripción', value: 'descripcion' },
                { text: 'Orígenes', value: 'origenes', sortable: false },
                { text: 'Usuarios', value: 'usuarios', sortable: false },
                { text: 'Fecha Creación', value: 'fechaCreacion' }
            ]
        }
    },
    watch: {
        step(val) {
            if (val == 1) {
                this.modalText = defaultText
            } else if (val == 2) {
                this.modalText = 'ACTUALIZAR'
            } else if (val == 3) {
                this.modalText = 'ELIMINAR'
            } else {
                this.modalText = 'VISUALIZAR'
            }
        }
    },
    computed: {
        ...mapGetters({
            listaCanales: 'canales/lista',
            origenLista: 'origen/lista',
            usuariosLista: 'usuarios/lista'
        }),
        ...mapGetters('perfilOrigen', ['lista']),
        ...mapState('perfilOrigen', ['datos'])
    },
    methods: {
        ...mapMutations({
            RESET_FORM: 'perfilOrigen/RESET_FORM',
            UPDATE_DATOS: 'perfilOrigen/UPDATE_DATOS',
            OPEN_MODAL: 'mainUI/OPEN_MODAL',
            OPEN_BAR: 'mainUI/OPEN_BAR'
        }),
        ...mapActions({
            handleGet: 'perfilOrigen/obtenerLista',
            handlePost: 'perfilOrigen/registrar',
            handlePut: 'perfilOrigen/actualizar',
            handleGetCanales: 'canales/obtenerLista',
            handleGetOrigen: 'origen/obtenerLista',
            handleGetUsuarios: 'usuarios/obtenerLista'
        }),
        getUsuariosCount(perfilId) {
            return this.usuariosLista.filter(u => u.idPerfilOrigen === perfilId).length
        },
        getOrigenName(idOrigen) {
            const ori = this.origenLista.find(o => o.id === idOrigen)
            return ori ? ori.descripcion : ''
        },
        getOrigenesByCanal(idCanal) {
            let items = this.origenLista.filter((o) => o.idCanal === idCanal)
            if (this.searchOrigen) {
                const search = this.searchOrigen.toLowerCase()
                items = items.filter((o) => o.descripcion.toLowerCase().includes(search))
            }
            return items
        },
        selectAllCanal(idCanal) {
            const origenes = this.getOrigenesByCanal(idCanal)
            origenes.forEach(ori => {
                if (!this.isOrigenSelected(ori.id)) {
                    this.selectedOrigenes.push({ idOrigen: ori.id, sameGroup: 1 })
                }
            })
        },
        deselectAllCanal(idCanal) {
            const origenes = this.getOrigenesByCanal(idCanal)
            const ids = origenes.map(o => o.id)
            this.selectedOrigenes = this.selectedOrigenes.filter(o => !ids.includes(o.idOrigen))
        },
        isOrigenSelected(idOrigen) {
            return this.selectedOrigenes.some((o) => o.idOrigen === idOrigen)
        },
        toggleOrigen(idOrigen, checked) {
            if (checked) {
                this.selectedOrigenes.push({ idOrigen, sameGroup: 1 })
            } else {
                this.selectedOrigenes = this.selectedOrigenes.filter((o) => o.idOrigen !== idOrigen)
            }
        },
        getSameGroup(idOrigen) {
            const found = this.selectedOrigenes.find((o) => o.idOrigen === idOrigen)
            return found ? !!found.sameGroup : false
        },
        toggleSameGroup(idOrigen, value) {
            const idx = this.selectedOrigenes.findIndex((o) => o.idOrigen === idOrigen)
            if (idx !== -1) {
                this.$set(this.selectedOrigenes, idx, { ...this.selectedOrigenes[idx], sameGroup: value ? 1 : 0 })
            }
        },
        EMPTY_FORM() {
            this.selectedOrigenes = []
            this.searchOrigen = ''
            this.openDialog = false
            this.loading = false
            this.loadingBTN = false
            this.menu = false
            this.selected = null
            this.openDelete = false
            this.openDocumento = false
            this.OPEN_MODAL({ state: false })
            this.step = 1
            this.RESET_FORM()
        },
        openForm(tipo, item) {
            this.step = tipo
            let status = false
            this.selected = item
            if (tipo == 1) {
                this.RESET_FORM()
                this.selectedOrigenes = []
                status = true
            } else if (tipo == 2) {
                if (!item) {
                    this.OPEN_BAR({ state: true, text: 'No hay selección', color: 'red' })
                } else {
                    status = true
                    this.selectedOrigenes = (item.origenes || []).map((o) => ({ idOrigen: o.idOrigen, sameGroup: o.sameGroup }))
                    this.UPDATE_DATOS({ ...item })
                }
            } else if (tipo == 3) {
                if (!item) {
                    this.OPEN_BAR({ state: true, text: 'No hay selección', color: 'red' })
                } else {
                    this.openDelete = true
                }
            } else if (tipo == 4) {
                if (!item) {
                    this.OPEN_BAR({ state: true, text: 'No hay selección', color: 'red' })
                } else {
                    status = true
                    this.selectedOrigenes = (item.origenes || []).map((o) => ({ idOrigen: o.idOrigen, sameGroup: o.sameGroup }))
                    this.UPDATE_DATOS({ ...item })
                }
            } else if (tipo == 5) {
                if (!item) {
                    this.OPEN_BAR({ state: true, text: 'No hay selección', color: 'red' })
                } else {
                    this.step = 1
                    this.modalText = 'REGISTRAR'
                    status = true
                    this.selectedOrigenes = (item.origenes || []).map((o) => ({ idOrigen: o.idOrigen, sameGroup: o.sameGroup }))
                    this.UPDATE_DATOS({ nombre: item.nombre + ' (copia)', descripcion: item.descripcion, activo: 1, origenes: [] })
                }
            }
            this.openDialog = status
        },
        async fnHandleCrud() {
            this.loadingBTN = true
            this.OPEN_MODAL({ state: true })
            if (this.step == 1) {
                await this.handlePost({ ...this.datos, origenes: this.selectedOrigenes })
            } else {
                const item = this.selected
                await this.handlePut({ ...item, nombre: this.datos.nombre, descripcion: this.datos.descripcion, origenes: this.selectedOrigenes })
            }
            await this.fnHandleGet({})
            this.EMPTY_FORM()
        },
        async fnHandlePut() {
            this.loadingBTN = true
            const item = this.selected
            if (this.step == 3) {
                const count = this.getUsuariosCount(item.id)
                if (count > 0) {
                    this.OPEN_BAR({ state: true, text: `No se puede eliminar: ${count} usuario(s) usan este perfil`, color: 'red' })
                    this.loadingBTN = false
                    return
                }
                item.activo = 0
            }
            await this.handlePut(item)
            await this.fnHandleGet({})
            this.EMPTY_FORM()
        },
        async fnHandleGet({ numeroDocumento = '' }) {
            this.loading = true
            await this.handleGet({ fechaFiltro: this.fechaFiltro, numeroDocumento })
            this.EMPTY_FORM()
        },

        downloadHandle() {
            this.loading = true
            const headers = ['id', 'nombre', 'descripcion', 'fechaCreacion']
            const filename = `REPORT_PERFIL_ORIGEN_${Date.now()}`
            exportXLSX({ headers, campos: headers, arrayData: this.lista }, { filename })
            this.loading = false
        },
        closeDocumento(nombreModal) {
            this[nombreModal] = false
        }
    },
    async created() {
        await this.fnHandleGet({})
        await this.handleGetCanales()
        await this.handleGetOrigen()
        await this.handleGetUsuarios({ all: true, status: true })
    }
}
</script>
